import { Injectable } from '@angular/core';
import { MenuSection } from '../models/types/sidebar-types';
import { Subscription } from 'rxjs';

export interface PermissionService {
  hasAuthPermissions: (perm: string) => { (): boolean };
  permissionsLoaded$?: { subscribe: (callback: (loaded: boolean) => void) => Subscription };
  signOut();
}

@Injectable({
  providedIn: 'root',
})
export class SidebarConfigService {
  private menuConfiguration: MenuSection[] = [];

  constructor() {
  }

  public getMenuSections(): MenuSection[] {
    const allSections = this.menuConfiguration.length > 0 ? this.menuConfiguration : [];
    return allSections;
  }

  public setMenuConfiguration(menuSections: MenuSection[]): void {
    this.menuConfiguration = menuSections;
  }
}
